import keyBy from 'lodash-es/keyBy'
import mapValues from 'lodash-es/mapValues'

import { EMPTY_LIST } from '../../../../../../../constants/common'
import {
  MATCH_RULES_ADDED_CRITERION,
  MATCH_RULES_FIELD_NAME_BUDGET_GATE,
  MATCH_RULES_FIELD_NAME_CRITERIA,
  MATCH_RULES_FIELD_NAME_GATING,
  MATCH_RULES_FIELD_NAME_WEIGHTS,
  MATCH_RULES_GATING_CRITERION,
  MATCH_RULES_GATING_FIELD,
} from '../ListingProfileApplicantsMatchRules.constants'
import { getMatchRulesScoredCriteria } from '../ListingProfileApplicantsMatchRules.utils'

export function getMatchRulesInitialValues(rules) {
  return {
    [MATCH_RULES_FIELD_NAME_BUDGET_GATE]: rules.budget_is_hard,
    [MATCH_RULES_FIELD_NAME_CRITERIA]: getMatchRulesScoredCriteria(rules).map(
      criterion => criterion.key
    ),
    [MATCH_RULES_FIELD_NAME_GATING]: {
      [MATCH_RULES_GATING_FIELD.maxOccupancy]: rules.max_occupancy?.value,
      [MATCH_RULES_GATING_FIELD.minOccupancy]: rules.min_occupancy,
      [MATCH_RULES_GATING_FIELD.petsPolicy]: rules.pets_policy,
      [MATCH_RULES_GATING_FIELD.wbsRequired]: rules.wbs_required,
    },
    [MATCH_RULES_FIELD_NAME_WEIGHTS]: mapValues(
      keyBy(rules.criteria, criterion => criterion.key),
      criterion => criterion.weight
    ),
  }
}

export function getHasMatchRulesGatingValue(criterion) {
  return Object.values(MATCH_RULES_GATING_CRITERION).includes(criterion.key)
}

export function getMatchRulesScoredRows({ criteria, rules }) {
  return criteria.map(
    key =>
      rules.criteria.find(criterion => criterion.key === key) ?? {
        ...MATCH_RULES_ADDED_CRITERION,
        key,
      }
  )
}

export function getMatchRulesAddOptions({ criteria, rules }) {
  return (rules.available_criteria ?? EMPTY_LIST).filter(
    option => !criteria.includes(option.key)
  )
}
